export default __webpack_public_path__ + "static/media/googleLogoIcon.0deb51c3.svg";